var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "editor-top-toolbar-view",
      class: {
        "editor-top-toolbar-view-compact-and-filled": _vm.isCompactAndFilled,
      },
    },
    [
      _c("div", { staticClass: "editor-top-toolbar-view-container" }, [
        _c(
          "div",
          { staticClass: "editor-top-toolbar-view-left-container" },
          [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.isPreviewModeActive ||
                      !_vm.hasPhotoSelected ||
                      (!_vm.isProjectSinglePage &&
                        !_vm.hasMultiplePhotoSupport &&
                        _vm.hasPhotoSelected),
                    expression:
                      "isPreviewModeActive || !hasPhotoSelected || (!isProjectSinglePage && !hasMultiplePhotoSupport && hasPhotoSelected)",
                  },
                ],
                staticClass: "back-button",
                on: { click: _vm.onBackClick },
              },
              [
                _c("IconComponent", [_vm._v("back_arrow")]),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "views.editorTopToolbar.buttons." +
                          (!_vm.isPreviewModeActive ? "back" : "back_to_edit")
                      )
                    )
                  ),
                ]),
              ],
              1
            ),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.isPreviewModeActive &&
                      (_vm.isProjectSinglePage ||
                        _vm.hasMultiplePhotoSupport) &&
                      _vm.hasPhotoSelected,
                    expression:
                      "!isPreviewModeActive && (isProjectSinglePage || hasMultiplePhotoSupport) && hasPhotoSelected",
                  },
                ],
                staticClass: "back-button",
                on: { click: _vm.onCancelClick },
              },
              [_vm._v(_vm._s(_vm.$t("views.editorTopToolbar.buttons.cancel")))]
            ),
            _vm.isCompactAndFilled
              ? _c("divider", { staticClass: "divider full" })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "editor-top-toolbar-view-center-container" },
          [_vm._t("center")],
          2
        ),
        _c(
          "div",
          { staticClass: "editor-top-toolbar-view-right-container" },
          [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isPreviewModeActive,
                    expression: "!isPreviewModeActive",
                  },
                ],
                staticClass: "undo-button",
                class: { disabled: !_vm.isUndoEnabled },
                on: { click: _vm.onUndoClick },
              },
              [_c("IconComponent", [_vm._v("undo")])],
              1
            ),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isPreviewModeActive,
                    expression: "!isPreviewModeActive",
                  },
                ],
                staticClass: "redo-button",
                class: { disabled: !_vm.isRedoEnabled },
                on: { click: _vm.onRedoClick },
              },
              [_c("IconComponent", [_vm._v("redo")])],
              1
            ),
            _c("divider", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isPreviewModeActive,
                  expression: "!isPreviewModeActive",
                },
              ],
              staticClass: "divider full",
            }),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.isPreviewModeActive &&
                      (!_vm.hasPhotoSelected ||
                        (_vm.hasPhotoSelected &&
                          !_vm.isProjectSinglePage &&
                          !_vm.hasMultiplePhotoSupport)),
                    expression:
                      "!isPreviewModeActive && (!hasPhotoSelected || (hasPhotoSelected && !isProjectSinglePage && !hasMultiplePhotoSupport))",
                  },
                ],
                staticClass: "save-button",
                on: { click: _vm.onSaveClick },
              },
              [
                _c("IconComponent", [_vm._v("save")]),
                !_vm.isMobile
                  ? _c("span", { staticClass: "save-text" }, [
                      _vm._v(
                        _vm._s(_vm.$t("views.editorTopToolbar.buttons.save"))
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm.isProjectSinglePage && !_vm.isMobile && _vm.isPreviewModeActive
              ? _c("PriceView", {
                  staticClass: "editor-top-toolbar-price-view",
                  attrs: {
                    cents: _vm.offeringModelPrice,
                    currency: _vm.currencyModel
                      ? _vm.currencyModel.id
                      : undefined,
                  },
                })
              : _vm._e(),
            _vm.isProjectSinglePage && !_vm.isMobile && _vm.isPreviewModeActive
              ? _c("divider", { staticClass: "divider full" })
              : _vm._e(),
            _vm.isProjectSinglePage && !_vm.isMobile && !_vm.hasPhotoSelected
              ? _c(
                  "ButtonComponent",
                  {
                    attrs: {
                      "font-size": !_vm.isMobile
                        ? "--font-size-m"
                        : "--font-size-s",
                      color: "primary",
                    },
                    on: { click: _vm.onDoneAdjustingClick },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("views.editorTopToolbar.buttons.done_adjusting")
                      )
                    ),
                  ]
                )
              : _vm._e(),
            (_vm.isProjectSinglePage || _vm.hasMultiplePhotoSupport) &&
            !_vm.isPreviewModeActive &&
            _vm.hasPhotoSelected
              ? _c(
                  "ButtonComponent",
                  {
                    attrs: {
                      color: !_vm.isCompactAndFilled ? "tertiary" : "primary",
                      "font-size": !_vm.isMobile
                        ? "--font-size-m"
                        : "--font-size-s",
                    },
                    on: { click: _vm.onDoneEditingClick },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        !_vm.isMobile
                          ? _vm.$t(
                              "views.editorTopToolbar.buttons.done_editing"
                            )
                          : _vm.$t("views.editorTopToolbar.buttons.done")
                      )
                    ),
                  ]
                )
              : _vm._e(),
            _vm.showAdditionalMenu
              ? [
                  _c("divider", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.isPreviewModeActive && !_vm.hasPhotoSelected,
                        expression: "!isPreviewModeActive && !hasPhotoSelected",
                      },
                    ],
                    staticClass: "divider full",
                  }),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.isPreviewModeActive && !_vm.hasPhotoSelected,
                          expression:
                            "!isPreviewModeActive && !hasPhotoSelected",
                        },
                      ],
                      ref: "additionalMenuButton",
                      staticClass: "additional-menu-button",
                      on: { click: _vm.onAdditionalMenuClick },
                    },
                    [_c("IconComponent", [_vm._v("additional_menu")])],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._t("bottom"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }